import { SupportedLanguage } from './index'

interface LocalizedString {
  ar?: string | null
  es?: string | null
  fr?: string | null
  pl?: string | null
  tl?: string | null
  vi?: string | null
  zh?: string | null
}

export const pickLocalized = (
  english: string | null | undefined,
  translations: LocalizedString | null | undefined,
  lang: SupportedLanguage
): string => {
  if (lang === 'en' || !translations) return english ?? ''
  return translations[lang] ?? english ?? ''
}
